import { initSmoothScrolling } from "./components/smoothScroll.js";
import { setPageTransition } from "./components/pagetransition.js";
import { splitText } from "./components/split.js";
import { createAccordion } from "./components/accordion.js";
import { makeSpline } from "./components/spline.js";
import {
  afterLoadedAnims,
  changeColor,
  sudopAnimations,
} from "./components/gsapAnim";

global.LENIS = [];
global.APP = [];
global.ANIM = [];

ANIM.section = [];
ANIM.color = [];
APP.TOUCH = require("detect-touch-device");
console.log(APP.TOUCH);
import Preload from "preload-it";
//
global.DESIGN = "https://prod.spline.design/9d1UcaPUeaKeVSpO/scene.splinecode";

initSmoothScrolling();

//
function init() {
  const article = document.querySelector("article");
  makeSpline(article.dataset.routerView);
  document.body.style.display = "block";
  afterLoadedAnims();
  setPageTransition();

  sudopAnimations(article.dataset.routerView);
  changeColor(article.dataset.routerView);
  createAccordion(article.dataset.routerView);
  splitText();
}
//
//
// stopOverscroll();

/********************************************* Preload  ****************************** */

let preload = Preload();
const itemsToLoad = [];

[...document.querySelectorAll("img")].forEach((el) => {
  var newSrc = el.getAttribute("src");
  if (!itemsToLoad.includes(newSrc)) {
    itemsToLoad.push(newSrc);
  }
});

preload.fetch(itemsToLoad).then((items) => {
  console.log(items);
});

preload.oncomplete = (items) => {
  // fetch(DESIGN, {
  //   credentials: "include",
  //   mode: "no-cors",
  // });
};

preload.onprogress = (event) => {
  // document.getElementById("progressNo").textContent = event.progress + "";

  if (event.progress > 99.9999999) {
    preload = null;
    document.body.classList.remove("loading");
    init();
    console.log("loaded");
  }
};

preload.onfetched = (item) => {};

preload.onerror = (item) => {};

/********************************************* Preload  ****************************** */

// if (!APP.TOUCH.isMobile) {
//   // makeSpline();
//   // const imgHoldery = document.querySelectorAll(".imgholder.bigImg");
//   // imgHoldery.forEach((el) => {
//   //   el.remove();
//   // });
// } else {
//   const canvasy = document.querySelectorAll("canvas");
//   canvasy.forEach((el) => {
//     el.remove();
//   });
// }
// const canvasy = document.querySelectorAll("canvas");
// canvasy.forEach((el) => {
//   el.remove();
// });
/********************************************* CHECK MENU  ****************************** */

const links = document.querySelectorAll("nav a");

for (let i = 0; i < links.length; i++) {
  const link = links[i];

  link.classList.remove("is-active");

  if (link.href === location.href) {
    link.classList.add("is-active");
  }
}
//
//
/********************************************* LISTENERS  ****************************** */
window.addEventListener("resize", (event) => {
  APP.TOUCH = require("detect-touch-device");
});

/********************************************* WHEN READY START ANIMATION  ****************************** */
document.addEventListener("DOMContentLoaded", function (event) {});
// const buttonslink = [...document.querySelectorAll("[data-section-story]")];
// buttonslink.forEach((el) => {
//   var aEl = el.querySelector("a.btn");

//   if (aEl) {
//     var link = aEl.getAttribute("href");
//     aEl.addEventListener("click", (event) => {
//       event.preventDefault();
//     });

//     el.addEventListener("click", (event) => {
//       event.preventDefault();
//       window.open(link, "_self");
//     });
//   }
// });
